import React from 'react';

import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';

interface BodyProps {
  children: React.ReactNode | string;
  className?: string;
}

function Body(props: BodyProps) {
  const { children, className } = props;
  return <Box className={cn(className, 'mb-32')}>{children}</Box>;
}

export default React.memo(Body);
